import React from 'react';
import classnames from 'classnames';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DataVendor } from 'v2/models';
import angleIcon from '../../icons/angle.svg';
import styles from './dataVendorsList.module.scss';
import Avatar from 'v2/Avatar/Avatar';
import defaultCompanyAvatar from 'v2/images/defaultCompanyAvatar.png';
import SortableColumn from '../SortableColumn/SortableColumn';
import { TranslationKeys, PostProcessKeys } from 'translations';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'v2/utils/dateUtils';

interface DataVendorsListProps {
  list: DataVendor[] | undefined;
  sortColumn?: string | null;
  onSortChange: (field: string) => void;
}

const DataVendorsList = ({
  list,
  sortColumn,
  onSortChange,
}: DataVendorsListProps) => {
  const { t } = useTranslation();

  const renderDataVendorsList = () => {
    return (
      <>
        {list?.map((item) => (
          <Link
            key={item.id}
            className="text-decoration-none"
            to={{
              pathname: `/data-provider-details/${item.id}/detail`,
              state: {
                backLinkTitle: t(TranslationKeys.dataVendor_other, {
                  postProcess: PostProcessKeys.TitleCase,
                }),
              },
            }}
            data-cy="drm:data-vendors-list"
          >
            <Card className="mb-3">
              <Card.Body className={classnames(styles.rowBody)}>
                <div
                  className={classnames(styles.tableRow, styles.columnStyle)}
                >
                  <div className="d-flex">
                    <Avatar
                      url={item.avatar_url || defaultCompanyAvatar}
                      className="mr-2"
                    />
                    <p
                      data-cy="data-vendor-name-text"
                      className={classnames(
                        'text-truncate pr-1 text-dark',
                        'd-flex align-items-center',
                        styles.lineHeight,
                        styles.companyName
                      )}
                    >
                      <>{item.name}</>
                    </p>
                  </div>
                  <p data-cy="data-vendor-classification-text">{`${item.classification}`}</p>
                  <div
                    data-cy="data-vendor-last-interaction-date-text"
                    className={classnames(
                      'text-light3 mr-5',
                      styles.lineHeight,
                      styles.noWrapingText
                    )}
                  >
                    {formatDate(item.last_interaction_date, true)}
                  </div>
                </div>
                <div className={classnames(styles.nextLink)}>
                  <img src={angleIcon} alt="angleIcon"></img>
                </div>
              </Card.Body>
            </Card>
          </Link>
        ))}
      </>
    );
  };

  if (!list?.length) {
    return <></>;
  }

  return (
    <div className={classnames('position-relative', styles.tableContainer)}>
      <div>
        <div className={classnames(styles.tableHeader, styles.columnStyle)}>
          <SortableColumn
            label={`${t(TranslationKeys.company_one, {
              postProcess: PostProcessKeys.TitleCase,
            })} Name`}
            ascField="name"
            descField="-name"
            className="pr-1 pl-1"
            currentField={sortColumn}
            onSortChange={onSortChange}
          />

          <SortableColumn
            label={`${t(TranslationKeys.provider_one, {
              postProcess: PostProcessKeys.TitleCase,
            })} Type`}
            ascField="classification"
            descField="-classification"
            className="pr-1 pl-1"
            currentField={sortColumn}
            onSortChange={onSortChange}
          />

          <SortableColumn
            label="Last Interaction"
            ascField="last_interaction_date"
            descField="-last_interaction_date"
            className="pr-1 pl-1"
            currentField={sortColumn}
            onSortChange={onSortChange}
          />
        </div>
        {renderDataVendorsList()}
      </div>
    </div>
  );
};

export default DataVendorsList;
